import type { ArticleLibraryKpis } from "@/core/services/types/article.types";

interface ArticlesLibraryKpisProps {
  kpis: ArticleLibraryKpis;
  sectionLabel: string;
  labels: {
    total: string;
    publishedThisMonth: string;
    pendingReview: string;
  };
}

function KpiCard({ label, value }: { label: string; value: number }) {
  return (
    <article className="wireframe-border bg-whart-bg p-4">
      <p className="text-sm text-neutral-600">{label}</p>
      <p className="mt-1 text-3xl font-semibold tracking-tight text-whart-text">
        {value.toLocaleString("fr-FR")}
      </p>
    </article>
  );
}

export function ArticlesLibraryKpis({
  kpis,
  sectionLabel,
  labels,
}: ArticlesLibraryKpisProps) {
  return (
    <section aria-label={sectionLabel} className="grid gap-4 sm:grid-cols-3">
      <KpiCard label={labels.total} value={kpis.total} />
      <KpiCard label={labels.publishedThisMonth} value={kpis.publishedThisMonth} />
      <KpiCard label={labels.pendingReview} value={kpis.pendingReview} />
    </section>
  );
}
